import { render, staticRenderFns } from "./cDocumentAddNew.vue?vue&type=template&id=3a9a5a5e&scoped=true"
import script from "./cDocumentAddNew.vue?vue&type=script&lang=js"
export * from "./cDocumentAddNew.vue?vue&type=script&lang=js"
import style0 from "./cDocumentAddNew.vue?vue&type=style&index=0&id=3a9a5a5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9a5a5e",
  null
  
)

export default component.exports